import ArtistHero from "@/Components/User/Artists/ArtistHero";
import ArtistsPodcast from "@/Components/User/Artists/ArtistPoadCast";
import ArtistStages from "@/Components/User/Artists/ArtistStages";
import Container from "@/Components/User/Common/Container";
import User from "@/Layouts/User";
import Head from "next/head";
import { useEffect } from "react";
import MetaTags from "@/Components/SEO/MetaTags";
import { Schema } from "@/Components/SEO/Schema";
import withBaseUrl from "@/Utils/const";
import AnimatedReveal from "@/Components/HOC/AnimatedReveal";
import { useLoading } from "@/context/loading";

export default function Index({ videos, result }) {
  const { isLoading } = useLoading();

  const getBreadcrumbs = () => {
    return [
      {
        name: "Home",
        url: withBaseUrl("/"),
      },
      {
        name: "For Artists",
        url: withBaseUrl("/for-artists"),
      },
    ];
  };

  return (
    <User>
      <Head>
        <title>For Artists | Qoncert</title>
        <Schema breadcrumbs={getBreadcrumbs()} />
      </Head>
      <MetaTags
        title="For Artists | Qoncert"
        description="Join Qoncert as an artist. Promote your shows, connect with fans, and grow your music career."
        ogImage="/assets/logo.webp"
        canonicalUrl="/for-artists"
      />
      <Container>
        <ArtistHero />
        <AnimatedReveal animation="fade-up" delay={isLoading ? 2.0 : 0}>
          <ArtistsPodcast data={videos} />
        </AnimatedReveal>
        <AnimatedReveal animation="fade-up" delay={isLoading ? 2.2 : 0}>
          <ArtistStages />
        </AnimatedReveal>
      </Container>
    </User>
  );
}

export async function getStaticProps() {
  const CHANNEL_ID = process.env.NEXT_PUBLIC_YOUTUBE_CHANNEL_ID;

  let videos = [];
  let result = {};

  try {
    const API_KEY = process.env.NEXT_PUBLIC_GOOGLE_YOUTUBE_KEY;
    const ytResponse = await fetch(
      `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=5`,
      { headers: { Accept: "application/json" } }
    );

    result = await ytResponse.json();
    videos = result.items || [];
  } catch (error) {
    console.error("Error fetching YouTube data:", error);
  }

  return {
    props: { videos, CHANNEL_ID, result },
    revalidate: 480,
  };
}
